import { render } from "./ProsesUnor.vue?vue&type=template&id=130a1d42"
import script from "./ProsesUnor.vue?vue&type=script&lang=js"
export * from "./ProsesUnor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__